import { LMSUserResponse } from '@nimbly-technologies/nimbly-common';
import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchLmsUserById } from 'services/lms/lmsUserManagement.service';
import * as actions from './lmsUserManagementUserById.action';

type FetchLmsUserByIdRequest = ReturnType<typeof actions.fetchLmsUserByIdAsync.request>;

function* fetchLmsUserByIdSaga(action: FetchLmsUserByIdRequest): Generator {
	try {
		const activity = (yield call(fetchLmsUserById, action.payload.userID) as unknown) as LMSUserResponse;

		yield put(actions.fetchLmsUserByIdAsync.success(activity));
	} catch {
		yield put(actions.fetchLmsUserByIdAsync.failure('Failed to get categories'));
	}
}

export default function* lmsUserManagementUserSaga() {
	// Every learner course and quiz component asks for the signed-in user on mount, so share the fetch in
	// flight for the same userID instead of sending one request per component
	const inFlight = new Set<string>();

	yield takeEvery(actions.fetchLmsUserByIdAsync.request, function* fetchOncePerUser(action: FetchLmsUserByIdRequest) {
		const { userID } = action.payload;
		if (inFlight.has(userID)) return;

		inFlight.add(userID);
		try {
			yield call(fetchLmsUserByIdSaga, action);
		} finally {
			inFlight.delete(userID);
		}
	});
}
